
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[slug]/page/[page]",
      function () {
        return require("private-next-pages/category/[slug]/page/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[slug]/page/[page]"])
      });
    }
  